import { Components, Theme } from "@mui/material/styles";

export const MuiTooltip: Components<Theme>["MuiTooltip"] = {
    defaultProps: {
        arrow: true,
        placement: "bottom",
    },
    styleOverrides: {
        tooltip: ({ theme }) => ({
            backgroundColor: theme.palette.common.white,
            color: theme.palette.gray[800],
            border: `1px solid ${theme.palette.gray[200]}`,
            borderRadius: "6px",
            padding: theme.spacing(2),
            maxWidth: "320px",
            fontSize: theme.typography.fontSize,
            fontWeight: theme.typography.fontWeightRegular,
            boxShadow: "unset",
        }),
        arrow: ({ theme }) => ({
            color: theme.palette.common.white,
            "&::before": {
                border: `1px solid ${theme.palette.gray[200]}`,
            },
        }),
    },
};
